/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_appsync_graphqlEndpoint": "https://64qsjmjfrnffrgkl5uitwbx2wa.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AWS_IAM",
    "aws_appsync_apiKey": "da2-lztmp5hy4rhejjeoyke653kyka",
    "aws_cognito_identity_pool_id": "eu-west-1:2112a305-4557-46bd-94a7-22c166f07f42",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_s1AbGVTpO",
    "aws_user_pools_web_client_id": "2urfgces6j1kt1t2fko9ne22r1",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "slalclientreporting-20230421130449-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "https://dluowrmxg03sf.cloudfront.net"
};


export default awsmobile;
